import axios from 'axios'
import MaggieHelper from '../../maggieHelper'

function extractError(error, errorCallback) {
  const response = error.response
  if (response.status == 403) {
    alert('403! You will now be logged out')
    localStorage.removeItem('backoffice-token')
  }
  let parsed = ''
  if (response) {
    parsed = 'Error: ' + response.status + ' (' + response.request.responseURL + '): ' + JSON.stringify(response.data)
  } else {
    parsed = error
    console.log('SYS ERROR', error)
  }
  if (typeof errorCallback === 'function') {
    errorCallback(error.response.data)
  } else {
    MaggieHelper.notification(response.data.result, response.data.messages, 'alert', response.data.result_code)
  }
}

function extractId(examine) {
  if (typeof examine === 'object') {
    return examine.id
  } else {
    return examine
  }
}

axios.interceptors.request.use((config) => {
  config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('backoffice-token')
  return config
})

const baseUrl = getBaseUrl()

function url() {
  return window.env.API_URL
}

function getBaseUrl(version = 'v1') {
  return url() + `/api/backoffice/${version}/`
}


function getUploadUrl(version = 'v1') {
  return `${window.env.API_URL}/api/${version}/attachment/upload`
}

const KeplerBackofficeSdk = {
  endpoint: baseUrl,
  getUrlForDropzone() {
    return getUploadUrl()
  },
  getSource() {
    return axios.CancelToken.source()
  },
  login: function (body, successCallback, errorCallback) {
    axios.post(baseUrl + 'login', body)
      .then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
      extractError(error, errorCallback)
    })
  },

  // The names of the resources have to be PLURAL
  examples: {
    // Calls that require and id (operations) need to be proxied through the 'select' function
    select: function (id) {
      // Use the helper to extract id from input if obj
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'example/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    // List calls have to be under 'list'
    list: {
      all: function (successCallback, errorCallback) {
        axios.get(baseUrl + 'examples').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },

  calls: {
    request: function (payload, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
      axios.post(baseUrl + 'clients/call', payload)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },

  charts: {
    for: function (start, end, bracketing) {
      const query = '?start=' + start + '&end=' + end + '&bracketing=' + bracketing
      return {
        charged_reservations: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'charts/charged-reservations' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        driven_distance: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/driven-distance' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        client_registrations: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/client-registrations' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        driver_registrations: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/driver-registrations' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        vehicle_reservations: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/vehicle-reservations' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        vehicle_distance: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/vehicle-distance' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        reservation_types: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/reservation-types' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        driver_stats: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'charts/driver-stats' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        vehicles_by_zone: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
          axios.get(baseUrl + 'charts/vehicles_by_zone' + query).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
  },
  vehicle: {
    select: function (id) {
      id = extractId(id)
      return {
        activateImmo(successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.post(`${baseUrl}vehicles/${id}/immo_on`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
  },
  vehicleSlots: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'vehicle_slot/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        enable: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'vehicle_slot/' + id + '/enable')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        disable: function (body, successCallback, errorCallback) {
          return axios.patch(baseUrl + 'vehicle_slot/' + id + '/disable', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },

        dismiss: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.post(`${baseUrl}vehicle_slots/${id}/dismiss`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        move: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.post(`${baseUrl}vehicle_slots/${id}/move`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        drain: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.post(`${baseUrl}vehicle_slots/${id}/drain`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    swap: function (body, successCallback, errorCallback,) {
      const baseUrl = getBaseUrl('v2')

      axios.post(`${baseUrl}vehicle_slots/swap`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    list: function (page = 1, perPage = 50, body) {
      return {

        allV2: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'vehicle_slots/').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        all: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'vehicle_slots/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        available: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'vehicle_slots/available').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        logs: function (entityId = null, successCallback, errorCallback) {
          return axios.get(baseUrl + 'logs/' + perPage + '/' + page + '/vehicle_slot/' + entityId)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },

    management: function (successCallback, errorCallback) {

      const url = getBaseUrl('v2')
      axios.get(`${url}vehicle_slots`).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    make: function (body, successCallback, errorCallback) {
      const url = getBaseUrl('v2')
      axios.post(`${url}vehicle_slots`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    search: function (body, successCallback, errorCallback) {
      axios.get(`${baseUrl}vehicle_slot/search/`, {params: body}).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  vehicles: {
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (body, successCallback, errorCallback) {
          axios.post(baseUrl + 'vehicles/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        fleetMap(body, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/vehicles/`
          return axios.get(baseUrl, {
            params: body
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        archive: function (id, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/vehicles/`
          axios.post(baseUrl + `${id}/archive`,).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })

        },
        movements: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'vehicle/' + body.vehicle_id + '/movements/' + perPage + '/' + page, {
            params: body
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        search: function (successCallback, errorCallback, cancelToken) {
          body.plate = body.query
          body.per_page = perPage
          body.page_number = page
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/vehicles`

          return axios.get(baseUrl, {
            params: body,
            cancelToken
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id, body) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'vehicle/' + id).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        availability: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'vehicle/' + id + '/availability', body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        getData: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'vehicle/' + id + '/data').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        openDoors: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.post(baseUrl + 'vehicles/' + id + '/open').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        closeDoors: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.post(baseUrl + 'vehicles/' + id + '/close').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          axios.put(baseUrl + 'vehicle/' + id + '/edit', body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        roi: function (start, end, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}vehicles/${id}/roi?start=${start}&end=${end}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        costs: function (start, end, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}vehicles/${id}/costs?start=${start}&end=${end}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        attributes: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}vehicles/${id}/attributes`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        forceRebook: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.post(`${baseUrl}vehicles/${id}/force_rebook`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        toggleHidden: function (body, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/vehicle-slots/${id}/toggle_hidden`

          return axios.patch(baseUrl, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'vehicle/add', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  notes: {
    list: function (page = 1, perPage = 50) {
      return {
        all: function (body = null, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'notes/', {
            params: {
              ...body,
              page_number: page,
              per_page: perPage
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}notes/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'notes', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  maintenanceRequest: {
    list: function (page = 1, perPage = 50) {
      return {
        all: function (body = null, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/intervention-requests`
          axios.get(baseUrl, {
            params: {
              ...body,
              page_number: page,
              per_page: perPage
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/intervention-requests`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/intervention-requests/${id}`
          return axios.delete(baseUrl)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        update: function (body, successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/intervention-requests/${id}`
          return axios.patch(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        complete: function (body, successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/intervention-requests/${id}/complete`
          return axios.patch(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
  },
  vehicleCost: {
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (body, successCallback, errorCallback) {

        },
      }
    },
    make: function (vehicleId, body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      axios.post(`${baseUrl}vehicles/${vehicleId}/add_cost`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
  },
  wallets: {
    select: function (id) {
      id = extractId(id)
      return {
        edit: function (body, successCallback, errorCallback) {
          body.payment_method_id = body.payment_method.id
          axios.post(baseUrl + 'wallet/' + id, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        manualCreditNote(body, successCallback, errorCallback) {
          // api/v3/backoffice/billing/wallets/{wallet}/manual_credit_note
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/wallets/${id}/manual_credit_note`

          return axios.post(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        billWallet(successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/wallets/${id}/bill`
          return axios.post(baseUrl).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    list: function (page = 1, perPage = 50) {
      return {
        records: function (walletId, successCallback, errorCallback) {
          return axios.get(baseUrl + 'wallet/' + walletId + '/records/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        refundable: function (walletId, search, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/wallets/${walletId}/refundable_records`

          let params = {
            page: page,
            limit: perPage,
            ...search
          }
          return axios.get(baseUrl, {
            params: params
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    make: function (body) {
      return {
        manualRecord: function (walletId, successCallback, errorCallback) {
          return axios.post(baseUrl + 'wallet/' + walletId + '/add_manual_record', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    }
    ,
  },
  walletRecords: {
    list: function (page = 1, perPage = 50) {
      return {
        uninvoiced: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/wallets/uninvoiced`
          return axios.get(baseUrl, {
            params: {
              page_number: page,
              per_page: perPage
            }
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    }
  },
  promotionalOffering: {
    select: function (slug) {
      return {
        get: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/promotional_offers/${slug}`
          return axios.get(baseUrl)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    list: function (page = 1, perPage = 50) {
      return {
        uninvoiced: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/billing/wallets/uninvoiced`
          return axios.get(baseUrl, {
            params: {
              page_number: page,
              per_page: perPage
            }
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    }
  },
  clients: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          return axios.get(baseUrl + 'client/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        suspend: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'client/' + id + '/suspend')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        activate: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'client/' + id + '/activate')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        delete: function (successCallback, errorCallback) {
          axios.delete(baseUrl + 'client/' + id + '/delete')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {

          axios.patch(baseUrl + 'client/' + id + '/edit', body)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        subscribe: function (plan_id, free_subscription, subscribe_main_driver, successCallback, errorCallback) {
          const body = {
            plan_id: plan_id,
            free_subscription: free_subscription,
            subscribe_main_driver: subscribe_main_driver,
          }
          return axios.post(baseUrl + 'client/' + id + '/subscribe', body)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        setMainDriver(driverId, successCallback, errorCallback) {
          axios.patch(baseUrl + 'client/' + id + '/main_driver/' + driverId)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        deposits(page_number, per_page, successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + id + '/deposits', {
            params: {
              page_number: page_number,
              per_page: per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        dump: function (successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'clients/' + id + '/dump')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        checkClientData: function (successCallback, errorCallback, lookupType) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
          axios.get(baseUrl + 'clients/' + id + '?lookup_type=' + lookupType)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    list: function (page = 1, perPage = 50, body,) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'clients/' + perPage + '/' + page, {...body,})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        search: function (successCallback, errorCallback, cancelToken) {
          const bodyClone = Object.assign({}, body)
          bodyClone.entity = 'client'
          let url = baseUrl + 'search?per_page=' + perPage + '&page_number=' + page
          return axios.post(url, bodyClone, {cancelToken})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        reservations: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + body.id + '/reservations/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        subscriptions: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + body.id + '/subscriptions/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        drivers: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + body.id + '/drivers/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        paymentMethods: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + body.id + '/payment_methods/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        wallets: function (clientId, successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}clients/${clientId}/wallets?uninvoiced=true`)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        cards: function (clientId, successCallback, errorCallback) {
          axios.get(baseUrl + 'client/' + clientId + '/cards/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        logs: function (entityId = null, successCallback, errorCallback) {
          axios.get(baseUrl + 'logs/' + perPage + '/' + page + '/client/' + entityId)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        approval: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          const params = {
            page_number: page,
            per_page: perPage,
            ...body
          }
          axios.get(baseUrl + 'clients/approval', {
            params: params
          }).then(function (response) {
            successCallback(response.data)
          })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    }
    ,
    make: function (body, successCallback, errorCallback) {
      var baseUrl = getBaseUrl('v2')
      axios.post(baseUrl + 'clients', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  clientTypes: {
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          axios.delete(baseUrl + 'client_type/' + id + '/delete')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          return axios.put(baseUrl + 'client_type/' + id + '/edit', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    list: function (page = 1, perPage = 50, body) {
      return {
        all: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'client_types/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'client_type/add', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  licenseTypes: {
    list: function () {
      return {
        all: function () {
          return [{id: 1, name: 'Patente b'}]
        }
      }
    }
  },
  drivers: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'driver/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        getLicences: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'driver/' + id + '/licenses')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        approve: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'driver/' + id + '/approve')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        suspend: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'driver/' + id + '/suspend')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        reactivate: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'driver/' + id + '/reactivate')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        delete: function (successCallback, errorCallback) {
          axios.delete(baseUrl + 'driver/' + id + '/delete')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        pictureDelete: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
          axios.post(baseUrl + 'drivers/' + id + '/delete-profile-picture')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

        edit: function (body, successCallback, errorCallback) {
          body['salutation'] = body['title']
          axios.put(baseUrl + 'driver/' + id + '/edit', body)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        setNewPassword: function (body, successCallback, errorCallback) {
          axios.put(baseUrl + 'driver/' + id + '/reset_password', body)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        sendPasswordResetLink(successCallback, errorCallback) {
          axios.get(baseUrl + 'driver/' + id + '/password/forgot')
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        tocs(successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}drivers/${id}/tocs`)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        setFlags: function (body, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/drivers/${id}/set-flags`

          return axios.put(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            })
            .catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    }
    ,
    sendNotification: function (body, successCallback, errorCallback) {
      const baseUrl = window.env.API_URL + `/api/v3/backoffice/drivers/send-notification`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'drivers/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        maintenance: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/drivers/maintenance`, {
            params: {
              page,
              perPage,
              ...body
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        reservations: function (driverId, successCallback, errorCallback) {
          axios.post(baseUrl + 'driver/' + driverId + '/reservations/' + perPage + '/' + page, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        subscriptions: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'driver/' + body.id + '/subscriptions')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        search: function (successCallback, errorCallback, cancelToken) {
          body.entity = 'driver'
          let url = baseUrl + 'search?per_page=' + perPage + '&page_number=' + page
          return axios.post(url, body, {cancelToken})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        coupons: function (page_number, per_page, successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/coupons-use/${body.id}`, {
            params: {
              page_number,
              per_page,
              ...body
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        cards: function (successCallback, errorCallback) {
          // console.log(body.id)
          axios.get(baseUrl + 'driver/' + body.id + '/cards/' + perPage + '/' + page)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        logs: function (entityId = null, successCallback, errorCallback) {
          axios.get(baseUrl + 'logs/' + perPage + '/' + page + '/driver/' + entityId)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        approval: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          const params = {
            page_number: page,
            per_page: perPage,
            ...body
          }

          axios.get(baseUrl + 'drivers/approval', {
            params: params
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        pendingDelete: function (successCallback, errorCallback) {
          const params = {
            page_number: page,
            per_page: perPage,
            ...body
          }
          return axios.get(window.env.API_URL + `/api/v3/backoffice/drivers/pending-deletion`, {
            params: params
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = getBaseUrl('v2')
      axios.post(baseUrl + 'drivers/', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  transit: {
    get: function (successCallback, errorCallback) {
      return axios.get(`${url()}/api/v3/public/transit/route-list`)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  driverPass: {
    list: function (page = 1, perPage = 50, body = null) {
      return {
        get: function (id, successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/drivers/${id}/transit-pass`

          return axios.get(baseUrl, {
            params: {
              page_number: page,
              per_page: perPage
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/drivers/${id}/transit-pass`

          return axios.get(baseUrl)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        delete: function (successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/transit/${id}`
          return axios.delete(baseUrl)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/transit/pass`

      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },

  driverLicenses: {
    list: function (page = 1, perPage = 50, body = null) {
      let search = body
      search.page_number = page
      search.per_page = perPage
      return {
        approval: function (successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'documents/approval', {
            params: search
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    select: function (id) {
      id = extractId(id)
      return {
        edit: function (body, successCallback, errorCallback) {
          body.issued_by = body.issuer.by
          body.issuer_country = body.issuer.country
          body.issued_date = body.issuer.date
          body.type = 1

          axios.put(baseUrl + 'driver_license/' + id + '/update', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        removeAttachment(attachmentId, successCallback, errorCallback) {
          axios.delete(baseUrl + 'driver_license/' + id + '/attachment/' + attachmentId + '/remove')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        addAttachment(body, successCallback, errorCallback) {
          axios.post(baseUrl + 'driver_license/' + id + '/attachment/attach', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        approve(successCallback, errorCallback) {
          axios.patch(baseUrl + 'driver_license/' + id + '/approve')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        delete(successCallback, errorCallback) {
          axios.delete(baseUrl + 'driver_license/' + id + '/delete')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        refuse(successCallback, errorCallback) {
          axios.post(baseUrl + 'driver_license/' + id + '/refuse')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      body.approved = true
      axios.post(baseUrl + 'driver/' + body.driver_id + '/license', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  documentTypes: {
    list: function () {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}document_types`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          return axios.delete(`${baseUrl}document_types/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        edit: function (body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}document_types/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'document_types', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }

  },
  documentRequirements: {
    list: function () {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}document_requirements`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          return axios.delete(`${baseUrl}document_requirements/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        edit(body, successCallback, errorCallback) {
          return axios.patch(window.env.API_URL + `/api/v3/backoffice/document-requirements/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    entityAllowed: function () {
      return {
        entityList: function (successCallback, errorCallback) {
          return axios.get(window.env.API_URL + `/api/v3/backoffice/document-requirements/types`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    // make: function (entityId, entity, body, successCallback, errorCallback) {
    make: function (body, successCallback, errorCallback) {
      let baseUrl = ''
      baseUrl = window.env.API_URL + `/api/v3/backoffice/document-requirements/types`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }

  },
  documents: {
    list: function () {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}document_requirements`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          axios.patch(`${baseUrl}documents/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      axios.post(baseUrl + 'documents/', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  alarms: {
    list: function (page = 1, perPage = 50) {

      return {
        all: function (successCallback, errorCallback, body = null) {
          const baseUrl = getBaseUrl('v2')
          const params = {
            per_page: perPage,
            page_number: page,
            ...body
          }
          return axios.get(`${baseUrl}vehicle_alarms`, {params})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    }
  },
  chargingSessions: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'reservation/' + id)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        start: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/charge-sessions/${id}/start`

          return axios.post(baseUrl)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        end: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/charge-sessions/${id}/end`

          return axios.post(baseUrl)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/charge-sessions`
          return axios.get(baseUrl, {

            params: {
              per_page: perPage,
              page_number: page,
              ...body
            }
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = window.env.API_URL + `/api/v3/backoffice/charge-sessions`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  preauth: {
    select: function (id) {
      id = extractId(id)
      return {
        cashIn: function (body, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/preauth/${id}/cash_in`
          return axios.post(baseUrl, body)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        cancel: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/preauth/${id}/cancel`
          return axios.post(baseUrl)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        refresh: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/preauth/${id}/refresh`
          return axios.post(baseUrl)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/charge-sessions`
          return axios.get(baseUrl, {

            params: {
              per_page: perPage,
              page_number: page,
              ...body
            }
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },

  },
  reservations: {
    // Calls that require and id (operations) need to be proxied through the 'select' function
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'reservation/' + id)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        open: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reservations/' + id + '/open')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        close: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reservations/' + id + '/close')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        cancel: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reservations/' + id + '/cancel')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        terminate: function (body, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/reservations/${id}/terminate`
          return axios.post(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        void: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reservations/' + id + '/void')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        replaceVehicleSlot: function (body, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/reservations/${id}`

          return axios.patch(baseUrl + '/vehicle_replace', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        complete: function (body, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/reservations/${id}`
          return axios.post(baseUrl + '/complete', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        extend: function (end_time, successCallback, errorCallback) {
          axios.patch(baseUrl + 'reservations/' + id + '/extend', {
            'end': end_time
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        resend(successCallback, errorCallback) {
          axios.post(baseUrl + 'reservation/' + id + '/resend_to_vehicle')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        debugInfo(successCallback, errorCallback) {
          axios.get(baseUrl + 'reservation/' + id + '/debug_info')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit(body, successCallback, errorCallback) {
          axios.post(baseUrl + 'reservations/' + id + '/edit', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        report(body, successCallback, errorCallback) {
          return axios.post(`${url()}/api/v3/backoffice/reservations/${id}/report`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        bookedTimes(successCallback, errorCallback) {
          axios.get(baseUrl + 'reservations/' + id + '/booked_times')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        deposits(successCallback, errorCallback) {
          axios.get(baseUrl + 'reservations/' + id + '/deposits')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        route(successCallback, errorCallback) {
          axios.get(baseUrl + 'reservation/' + id + '/route')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        reconciliate(successCallback, errorCallback) {
          return axios.post(`${url()}/api/v3/backoffice/reservations/${id}/reconciliate`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        uncoveredAmount(successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/reservations/${id}/uncovered_amount`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        cleanUp(successCallback, errorCallback) {
          return axios.post(`${url()}/api/v3/backoffice/reservations/${id}/clean_up`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        requestPreauth: function (amount, successCallback, errorCallback) {
          const baseUrl = window.env.API_URL + `/api/v3/backoffice/reservations/${id}/request_preauth`
          return axios.post(baseUrl, {amount})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        replaceMaintenanceDriver(body, successCallback, errorCallback) {
          return axios.patch(`${url()}/api/v3/backoffice/reservations/${id}/replace_maintenance_driver`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.post(baseUrl + 'reservations/' + perPage + '/' + page, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        search: function (successCallback, errorCallback, cancelToken) {
          body.entity = 'reservation'
          axios.post(baseUrl + 'search?per_page=' + perPage + '&page_number=' + page, body, {cancelToken})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        modes: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/reservations/available_booking_types`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        driversReservationRequests(filter, successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/driver-reservation-requests`, {
            params: {
              per_page: perPage,
              page_number: page,
              ...filter
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        preauths(body, successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/reservations/${body.reservation_id}/preauths`, {
            params: {
              per_page: perPage,
              page_number: page,
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
    ,
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'reservations', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    makeDriverRequestBooking(requestId, body, successCallback, errorCallback) {
      return axios.post(`${url()}/api/v3/backoffice/reservations/reservation_request/${requestId}/book`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    rejectDriverRequestBooking(requestId, successCallback, errorCallback) {
      return axios.delete(`${url()}/api/v3/backoffice/driver-reservation-requests/${requestId}`)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    updateStatusRequest(requestId, body, successCallback, errorCallback) {
      return axios.patch(`${url()}/api/v3/backoffice/driver-reservation-requests/${requestId}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    planning(body, successCallback, errorCallback) {
      return axios.post(`${url()}/api/v3/backoffice/reservations/find_vehicle_for_shifts`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    bookPlanning(body, successCallback, errorCallback) {
      return axios.post(`${url()}/api/v3/backoffice/reservations/book_planning`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },

  },
  subscriptions: {
    select: function (id, body = null) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'subscription/' + id)
            .then(function (response) {
              return successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        removeDriver: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'subscriptions/remove_driver', {
            subscription_id: id,
            driver_id: body.driver_id
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        addDriver: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'subscriptions/associate_driver', {
            subscription_id: id,
            driver_id: body.driver_id
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        renew: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'subscription/' + id + '/renew')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        disable: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'subscription/' + id + '/void')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          axios.patch(baseUrl + 'subscription/' + id, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          axios.delete(baseUrl + 'subscription/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

      }
    }
    ,
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'subscriptions/' + perPage + '/' + page, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
  },
  invoices: {
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/' + perPage + '/' + page, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        paid: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'PAID'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        onHold: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'ON HOLD'
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        awaitingPayment: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'AWAITING PAYMENT'
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        noPaymentMethod: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'NO PAYMENT METHOD'
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        sent: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'SENT'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        overDue: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'OVERDUE'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        canceled: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'invoices/1000/1', {
            status: 'CANCELED'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        client: function (successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}billing/invoices/${body.client_id}`, {
            params: {
              per_page: perPage,
              page_number: page,
              ...body
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
    ,
    select: function (id) {
      id = extractId(id)
      return {
        get(successCallback, errorCallback) {
          axios.get(baseUrl + 'invoice/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        payInvoice(successCallback, errorCallback) {
          axios.post(baseUrl + 'invoice/' + id + '/pay')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        setPaid(successCallback, errorCallback) {
          axios.post(baseUrl + 'invoice/' + id + '/payed')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        setAwaitingPayment(successCallback, errorCallback) {
          return axios.patch(`${url()}/api/v3/backoffice/billing/invoices/${id}/mark_awaiting_payment`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              console.log(error)
              extractError(error, errorCallback)
            })
        },
        voidInvoice(body, successCallback, errorCallback) {
          return axios.post(baseUrl + 'invoice/' + id + '/void', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        downloadXML(successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}modules/italian-e-invoice/download/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        downloadZucchetti(body, successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}modules/zucchetti/download/${id}`, {
            params: {...body}
          })
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        sendToSdi(successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          return axios.post(`${baseUrl}modules/aruba-italian-e-invoice/upload/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        getStatus(successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}modules/aruba-italian-e-invoice/get_status/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        updateFilename(body, successCallback, errorCallback) {
          var baseUrl = getBaseUrl('v2')
          return axios.post(`${baseUrl}modules/aruba-italian-e-invoice/update_filename/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        convertToCreditNote(body, successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/billing/invoices/${id}/proforma_to_credit_note`
          return axios.patch(baseUrl, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    archiveXml(body) {
      var baseUrl = getBaseUrl('v2')
      const token = localStorage.getItem('backoffice-token')
      let url = `${baseUrl}modules/italian-e-invoice/archive?driver_id=0&token=${token}&emission_from=${body.from}&emission_to=${body.to}`
      if (body.type != null) {
        url += `&type=${body.type}`
      }
      return url
    },
  },
  reportings: {
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reportings/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        types: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reportings/types').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'reportings/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        setVoided: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reportings/' + id + '/status', {
            status: 'VOIDED'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        setConfirmed: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reportings/' + id + '/status', {
            status: 'CONFIRMED'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        setResolved: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'reportings/' + id + '/status', {
            status: 'RESOLVED'
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          axios.patch(baseUrl + 'reportings/' + id + '/edit', body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
    ,
    make: function (vehicleId, body, successCallback, errorCallback) {
      axios.post(baseUrl + 'reportings/' + vehicleId, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  vehicleCategories: {
    list: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'vehicle_categories')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        addPicture(body, successCallback, errorCallback) {
          axios.put(`${baseUrl}vehicle_category/${id}/add_picture`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit(body, successCallback, errorCallback) {
          axios.patch(`${baseUrl}vehicle_category/${id}/edit`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove(successCallback, errorCallback) {
          return axios.delete(`${url()}/api/v3/backoffice/vehicle-category/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'vehicle_category/add', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  cards: {
    select: function (id) {
      id = extractId(id)
      return {
        edit: function (body, successCallback, errorCallback) {
          axios.post(baseUrl + 'cards/' + id + '/edit', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        unbind: function (successCallback, errorCallback) {
          axios.patch(baseUrl + 'cards/' + id + '/unbind')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          axios.delete(baseUrl + 'cards/' + id + '/delete')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
    ,
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'cards/search?per_page=' + perPage + '&page_number=' + page, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        unassigned: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'cards/search?per_page=1000&page_number=1&driver_id=null')
            .then((response) => {
              successCallback(response.data)
            }).catch((error) => {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'cards', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  plans: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'plans/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(baseUrl + 'plans/' + id, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        rates: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}plans/${id}/rates`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    list: function () {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'plans/')
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'plans', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  selects: {
    vehicleBrands: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/vehicle_brands')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    vehicleCategories: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/vehicle_categories')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    clients: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/clients')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    plans: function (disabled = null, successCallback, errorCallback) {
      axios.get(baseUrl + 'select/plans?disabled=' + disabled)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    vehicles: function (disabledSlot = 0, archived = 0, successCallback, errorCallback) {
      axios.get(baseUrl + 'select/vehicles?disabledSlot=' + disabledSlot + '&archived=' + archived)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    vehicleSlots: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/vehicle_slots')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    drivers: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/drivers')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    reportingTypes: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/reporting_types')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    timeRates: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/time_rates')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
    distanceRates: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'select/distance_rates')
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  reports: {
    list: function (body = null) {
      return {
        vehicles: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reports/vehicles', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        reservations: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reports/reservations', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        clients: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reports/clients', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        subscriptions: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reports/subscriptions', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        invoices: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'reports/invoices', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

      }
    }
    ,
  },
  transactions: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          axios.get(baseUrl + 'transactions/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        refund: function (body, successCallback, errorCallback) {
          axios.patch(baseUrl + 'transactions/' + id + '/refound', body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
    ,
    list: function (page = 1, perPage = 50, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          axios.post(baseUrl + 'transactions/' + perPage + '/' + page, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
  },
  logs: {
    list: function (page = 1, perPage = 50) {
      return {
        all: function (entity = null, entityId = null, successCallback, errorCallback) {
          axios.get(baseUrl + 'logs/' + perPage + '/' + page + '/' + entity + '/' + entityId)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    }
  },
  timeOverrides: {
    select: function (id) {
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          axios.patch(baseUrl + 'time_overrides/' + id, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove(successCallback, errorCallback) {
          axios.delete(baseUrl + 'time_overrides/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }

    }
    ,
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'time_overrides', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  bulkOverrides: {
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'bulk_overrides', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove(successCallback, errorCallback) {
          axios.delete(baseUrl + 'bulk_overrides/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }

    }
  },
  distanceOverrides: {
    select: function (id) {
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          axios.patch(baseUrl + 'distance_overrides/' + id, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove(successCallback, errorCallback) {
          axios.delete(baseUrl + 'distance_overrides/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }

    }
    ,
    make: function (body, successCallback, errorCallback) {
      axios.post(baseUrl + 'distance_overrides', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
    ,
  },
  timeRates: {
    make: function (body, successCallback, errorCallback) {
      return axios.post(baseUrl + 'time_rates', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
    ,
  },
  distanceRates: {
    make: function (body, successCallback, errorCallback) {
      return axios.post(baseUrl + 'distance_rates', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
    ,
  },
  configuration: {
    get: function (successCallback, errorCallback) {
      axios.get(baseUrl + 'config')
        .then((response) => {
          successCallback(response.data)
        }).catch((error) => {
        extractError(error, errorCallback)
      })
    },
    getPromise: () => {
      return axios.get(baseUrl + 'config')
    },
    update: function (key, value, successCallback, errorCallback) {
      axios.patch(baseUrl + 'config', {key: key, value: value})
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  parkingGroups: {
    select: function (id) {
      id = extractId(id)
      return {
        get(successCallback, errorCallback) {
          axios.get(baseUrl + 'parking_group/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit(body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.post(baseUrl + 'parking_groups/' + id, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove(successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(baseUrl + 'parking_groups/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        parkingLots(body, successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/parking-group/${id}/parking_lots`, {
            params: body
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        axios.get(baseUrl + 'parking_groups').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      allv3: function (successCallback, errorCallback) {
        return axios.get(`${url()}/api/v3/backoffice/parking-group`, {
          params: {
            per_page: -1,
            page_number: 1
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },

    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      axios.post(baseUrl + 'parking_groups', body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })

    }
  },
  parkingLots: {
    list: {
      all: function (successCallback, errorCallback) {
        axios.get(baseUrl + 'parking_lots').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
    select: function (id) {
      id = extractId(id)
      return {
        get(successCallback, errorCallback) {
          axios.get(baseUrl + 'parking_lot/' + id)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        update: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.post(baseUrl + `parking_lots/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(baseUrl + `parking_lots/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make(body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      axios.post(`${baseUrl}parking_lots`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  parkingSlots: {
    select: function (id) {
      id = extractId(id)
      return {
        update: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.post(baseUrl + `parking_slots/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(baseUrl + `parking_slots/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        archive: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(baseUrl + `parking_slots/${id}/archive`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(baseUrl + 'parking_slots').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      slots: function (lotId, successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}parking_lots/${lotId}/slots`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
    make(body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      axios.post(`${baseUrl}parking_slots`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  zones: {
    select: function (id) {
      id = extractId(id)
      return {
        get(successCallback, errorCallback) {
          axios.get(baseUrl + `zone/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        update: function (body, successCallback, errorCallback) {
          axios.patch(baseUrl + `zone/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          axios.delete(baseUrl + `zone/${id}/delete`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        getGeoJson: function (successCallback, errorCallback) {
          axios.get(`${url()}/api/v3/backoffice/zone/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        axios.get(baseUrl + 'zone').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      grouped(successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(baseUrl + 'zone').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
    make(body, successCallback, errorCallback) {
      axios.put(`${baseUrl}zone/add`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    mergeGeoJson(body, successCallback, errorCallback) {
      axios.post(`${url()}/api/v3/backoffice/zone/geojson/merge`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  vehicleTypes: {
    list: {
      all: function (successCallback, errorCallback) {
        axios.get(baseUrl + 'vehicle_types').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove(successCallback, errorCallback) {
          axios.delete(`${url()}/api/v3/backoffice/vehicle-types/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v1')

      axios.post(`${baseUrl}vehicle_type/add`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  vehicleHardware: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')

      axios.post(`${baseUrl}vehicle_hardwares`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })

    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}vehicle_hardwares/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.post(`${baseUrl}vehicle_hardwares/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }

    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(baseUrl + 'vehicle_hardwares').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      managers: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(baseUrl + 'vehicle_hardwares/managers').then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
  },
  files: {
    uploadImage: function (file, visibility, prefix, filename, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')

      let formData = new FormData()
      formData.append('file', file)
      formData.append('visibility', visibility)
      formData.append('prefix', prefix)
      formData.append('filename', filename)

      axios.post(baseUrl + 'files/upload', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    remove(internalPath, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.delete(baseUrl + 'files', {
        params: {
          path: internalPath
        }
      }).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    list: {
      public: function (prefix = null, successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        return axios.get(baseUrl + 'files/index_public', {
          params: {prefix}
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    }
  },
  assetCosts: {
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}asset_costs/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      types: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}asset_costs/types`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },

    },
  },
  planReservationRates: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}plan_reservation_rates/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}plan_reservation_rates/${body.id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}plan_reservation_rates/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}plan_reservation_rates`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
  },
  reservationRates: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}reservation_rates`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}reservation_rates/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}reservation_rate/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}reservation_rates/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      rates: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}reservation_rates`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },

    },
  },
  tocTypes: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}toc_types`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {

        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}toc_types/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}toc_types/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}toc_types`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },

    },
  },
  payment_methods: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}payment_methods`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}payment_methods/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    }
  },
  tocs: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}tocs`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}tocs/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}tocs/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}tocs/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}tocs`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },

    },
  },
  instructions: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}instructions`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}instructions/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}instructions/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}instructions/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}instructions`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  vehicleInstructions: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}vehicle_instructions`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}vehicle_instructions/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}vehicle_instructions/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}vehicle_instructions/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}vehicle_instructions`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  vehicleAttributes: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}vehicle_attributes`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}vehicle_attributes/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}vehicle_attributes/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}vehicle_attributes/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}vehicle_attributes`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  vehicleVehicleAttributes: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}vehicle_vehicleattributes`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {

        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}vehicle_vehicleattributes/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.delete(`${baseUrl}vehicle_vehicleattributes/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}vehicle_attributes`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  reportingTypes: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}reporting_types`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.patch(`${baseUrl}reporting_types/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}vehicle_attributes`).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  console: {
    run: function (command, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}console`, {
        'command': command
      }).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        errorCallback(error)
      })
    },
    list: function (successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.get(`${baseUrl}console`).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        errorCallback(error)
      })
    },
  },
  credits: {
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}billing/credits/${body.client_id}/promo`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    makePaid: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}billing/credits/${body.client_id}/paid`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    select: function (id) {
      id = extractId(id)
      return {
        balance: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}billing/${id}/balance`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        expire: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}billing/credits/${id}/expire`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    list: {
      all: function (body, page_number, per_page, successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}billing/credits/${body.client_id}`, {
          params: {
            per_page: per_page,
            page_number: page_number,
            ...body
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
    usages: function (recordId, page_number, per_page, successCallback, errorCallback) {
      return axios.get(`${url()}/api/v3/backoffice/billing/credits/${recordId}/usages`, {
        params: {
          per_page: per_page,
          page_number: page_number,
        }
      }).then((response) => {
        console.log(response.data)
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  topUps: {
    list: {
      all: function (client_id, page_number, per_page, successCallback, errorCallback) {
        const baseUrl = getBaseUrl('v2')
        axios.get(`${baseUrl}billing/${client_id}/top_ups`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
  },
  packetRecords: {
    list: {
      all: function (client_id, page_number, per_page, successCallback, errorCallback) {
        return axios.get(window.env.API_URL + `/api/v3/backoffice/clients/${client_id}/packets`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      usages: function (recordId, page_number, per_page, successCallback, errorCallback) {
        return axios.get(window.env.API_URL + `/api/v3/backoffice/packet-records/${recordId}/usages`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then((response) => {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
  },
  policies: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.get(baseUrl + 'policies/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}policies/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}policies/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}policies/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'policies', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  commonCosts: {
    list: function () {
      return {
        all: function (page_number, per_page, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}common_costs`, {
            params: {
              per_page: per_page,
              page_number: page_number,
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}common_costs/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        delete(successCallback, errorCallback) {
          return axios.delete(`${baseUrl}common_costs/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        addToWallet(body, successCallback, errorCallback) {
          return axios.post(`${baseUrl}common_costs/${id}/add_to_wallet`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'common_costs/', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  packets: {
    list: {
      all: function (page_number = 1, per_page = 25, successCallback, errorCallback) {
        axios.get(window.env.API_URL + `/api/v3/backoffice/packets`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(window.env.API_URL + `/api/v3/backoffice/packets/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      return axios.post(window.env.API_URL + `/api/v3/backoffice/packets`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  packetVehicleCategories: {
    list: {
      all: function (page_number = 1, per_page = 25, successCallback, errorCallback) {
        axios.get(window.env.API_URL + `/api/v3/backoffice/packet-vehicle-category`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(window.env.API_URL + `/api/v3/backoffice/packet-vehicle-category/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        delete(body, successCallback, errorCallback) {
          return axios.delete(window.env.API_URL + `/api/v3/backoffice/packet-vehicle-category/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      return axios.post(window.env.API_URL + `/api/v3/backoffice/packet-vehicle-category`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  translations: {
    list: {
      all: function (page_number = 1, per_page = 25, successCallback, errorCallback) {
        axios.get(window.env.API_URL + `/api/v3/backoffice/translation`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
      overridable: function (groups, key, successCallback, errorCallback) {
        return axios.get(window.env.API_URL + `/api/v3/backoffice/translation/langs/overridable`, {
          params: {
            groups,
            key
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          return axios.get(window.env.API_URL + `/api/v3/backoffice/translation/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        update: function (body, successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/translation/${id}/update`
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove: function (successCallback, errorCallback) {
          var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
          return axios.delete(`${baseUrl}translation/${id}?XDEBUG_SESSION_START`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/translation`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  commonCostType: {
    list: {
      all: function (page_number = 1, per_page = 25, successCallback, errorCallback) {
        axios.get(window.env.API_URL + `/api/v3/backoffice/common-cost-type`, {
          params: {
            per_page: per_page,
            page_number: page_number,
          }
        }).then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
      },

    },

    make: function (body, successCallback, errorCallback) {
      let baseUrl = ''
      baseUrl = window.env.API_URL + `/api/v3/backoffice/common-cost-type`
      axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },

    edit: function (body, successCallback, errorCallback) {
      let baseUrl = ''
      baseUrl = window.env.API_URL + `/api/v3/backoffice/common-cost-type/${body.id}/update`
      axios.patch(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
  },
  zoneConfigurations: {
    list: function () {
      return {
        all: function (page_number, per_page, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}zone_configs/`, {
            params: {
              page_number: page_number,
              per_page: per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          return axios.get(`${baseUrl}zone_configs/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}zone_configs/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }, delete(successCallback, errorCallback) {
          return axios.delete(`${baseUrl}zone_configs/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'zone_configs/', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  reservationFlags: {
    list: function () {
      return {
        all: function (page_number, per_page, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}zone_configs/`, {
            params: {
              page_number: page_number,
              per_page: per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      var baseUrl = getBaseUrl('v2')
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          return axios.get(`${baseUrl}zone_configs/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}reservation_flags/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        }, delete(successCallback, errorCallback) {
          return axios.delete(`${baseUrl}reservation_flags/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (id, body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + `reservation_flags/${id}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  groups: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.get(baseUrl + 'groups/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(`${baseUrl}groups/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}groups/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        drivers: function (page_number, per_page, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}groups/${id}/drivers`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}groups/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'groups', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },

  driverGroups: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.get(baseUrl + 'groups/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        detach: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          console.log(body)
          return axios.delete(`${baseUrl}driver_groups/${id}`, {data: body}).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        toggleSupervisor: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}driver_groups/${id}/supervisor`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'groups', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  vehiclePolicies: {
    list: function (id, page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          axios.get(`${baseUrl}vehicle_policies/${id}`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}vehicle_policies/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}vehicle_policies/${body.vehicle_id}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  driverPolicies: {
    list: function (id, page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')

          return axios.get(`${baseUrl}driver_policies/${id}`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}driver_policies/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(`${baseUrl}driver_policies/${body.driver_id}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  hooks: {
    manual(body, successCallback, errorCallback) {
      axios.post(`https://core.staging.playmoove.com/hooks/manual`, body).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    vehicleStatus(hw, successCallback, errorCallback) {
      axios.get(`https://core.staging.playmoove.com/api/v2/vehicles/status/${hw}`).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  federations: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(baseUrl + 'federations/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}federations/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        updateFederated: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}federations/${id}/update_federated`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },

      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'federations', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  federationVehicles: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback, page_number = 1, per_page = 25) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}federations/${id}/vehicles`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

  },
  federationParkingGroups: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback, page_number = 1, per_page = 25) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}federations/${id}/parking_groups`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

  },
  federationClients: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback, page_number = 1, per_page = 25) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}federations/${id}/clients`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

  },
  federationConfig: {
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/${id}/configuration`

          return axios.get(baseUrl,).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        update: function (body, successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/${id}/configuration`

          return axios.patch(baseUrl, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        delete: function (body, successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/${id}/configuration`
          return axios.delete(baseUrl, {data: body}).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

  },
  federationEntities: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (id, successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/${id}/entities`
          return axios.get(baseUrl, {
            params: {
              page_number,
              per_page,
              "entity_type":"App\\Models\\DocumentType"
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    make: function (federationId, body, successCallback, errorCallback) {
      const baseUrl = `${url()}/api/v3/backoffice/federation/${federationId}/entities`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/${id}/entities`

          return axios.get(baseUrl,).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        delete: function (successCallback, errorCallback) {
          const baseUrl = `${url()}/api/v3/backoffice/federation/entities/${id}/`
          return axios.delete(baseUrl).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },

  },
  users: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'users/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}users/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        remove: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.delete(`${baseUrl}users/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}users/${id}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },

      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'users', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    profile() {
      const baseUrl = getBaseUrl('v2')
      return axios.get(baseUrl + 'users/profile')
    }
  },
  roles: {
    list: function (page_number = 1, per_page = 50) {
      return {
        all: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'roles/', {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        permissions: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          axios.get(baseUrl + 'roles/permissions').then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      id = extractId(id)
      return {
        get: function (successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.get(`${baseUrl}roles/${id}`).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        edit: function (body, successCallback, errorCallback) {
          const baseUrl = getBaseUrl('v2')
          return axios.patch(`${baseUrl}roles/${id}`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      const baseUrl = getBaseUrl('v2')
      return axios.post(baseUrl + 'roles', body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
  },
  userConfig: {
    list: function () {
      const baseUrl = getBaseUrl('v2')
      return axios.get(baseUrl + 'user_configs/')
    }
  },
  sentinel: {
    list: function (page_number, per_page, body) {
      return {
        all: function (successCallback, errorCallback) {
          body.page_number = page_number
          body.per_page = per_page
          return axios.get(`${url()}/api/v3/backoffice/sentinel`, {
            params: body
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
  },
  export: {
    getCsv(report, body) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
      const token = localStorage.getItem('backoffice-token')
      let url = `${baseUrl}export?driver_id=0&token=${token}&entity=${report}&format=csv`

      if (body.start) url += `&start=${body.start}`
      if (body.end) url += `&end=${body.end}`
      if (body.params && typeof body.params === 'object') {
        const params = Object.keys(body.params).filter(k => !!body.params[k]).map(k => `${k}|${body.params[k]}`).join('-')
        if (params) url += '&params=' + params
      }
      return url
    },
    getTypes(successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/`
      return axios.get(`${baseUrl}export/types`).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
  },

  cargo: {
    cargoOperationCreate(body, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/cargo`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    operationList(page_number, per_page, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/cargo`
      return axios.get(`${baseUrl}`, {
        params: {
          page_number,
          per_page
        }
      }).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    getOperation(id, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/cargo`
      return axios.get(`${baseUrl}/${id}`).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    import(file, successCallback, errorCallback) {
      var baseUrl = getBaseUrl('v1')//window.env.API_URL + `/backoffice/v1/attachment/upload` //getUploadUrl()
      var formData = new FormData();
      formData.append("attachment", file);
      return axios.post(`${baseUrl}attachment/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    },
    stop(id, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/cargo/${id}/stop`
      return axios.post(baseUrl).then(function (response) {
        successCallback(response.data)
      }).catch(function (error) {
        extractError(error, errorCallback)
      })
    }
  },
  clone: {
    cloneVehicle(body, successCallback, errorCallback) {
      var baseUrl = window.env.API_URL + `/api/v3/backoffice/import-clone`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },

  },
  coupons: {
    list: function (page_number, per_page, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/coupons`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        list: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/coupons-use/list`, {
            params: {
              page_number,
              per_page,
              ...body
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/coupons/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/coupons`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  segments: {
    list: function (page_number, per_page, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/segments`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/segments/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        vehicles(page_number, per_page, successCallback, errorCallback) {
          return axios.get(`${baseUrl}/vehicles`, {
            params: {
              page_number,
              per_page,
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        addVehicles(body, successCallback, errorCallback) {
          return axios.post(`${baseUrl}/vehicles`, body).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
        removeVehicles(body, successCallback, errorCallback) {
          console.log(body)
          return axios.delete(`${baseUrl}/vehicles`, {data: body}).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/segments`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  segmentRates: {
    list: function (page_number, per_page, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/segment-rates`, {
            params: {
              page_number,
              per_page,
              segment_id: body
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        }
      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/segment-rates/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove(successCallback, errorCallback) {
          return axios.delete(`${baseUrl}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/segment-rates`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  segmentAttributes: {

    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/segment-attributes/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            })/*.catch(function (error) {
              extractError(error, errorCallback)
            })*/
        },
        delete(successCallback, errorCallback) {
          return axios.delete(`${baseUrl}`)
            .then(function (response) {
              successCallback(response.data)
            })/*.catch(function (error) {
              extractError(error, errorCallback)
            })*/
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      console.log(body)
      var baseUrl = `${url()}/api/v3/backoffice/segment-attributes`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        })/*.catch(function (error) {
          extractError(error, errorCallback)
        })*/
    }
  },

  notifications: {
    list: function (page_number = 1, per_page = 10, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(window.env.API_URL + `/api/v3/backoffice/notifications?limit=${per_page}&page=${page_number}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    }
  },
  registrationTokens: {
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/registration-tokens`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    },
    list: function (page_number = 1, per_page = 10, body = null) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(window.env.API_URL + `/api/v3/backoffice/registration-tokens?per_page=${per_page}&page_number=${page_number}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/registration-tokens/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove: function (successCallback, errorCallback) {
          return axios.delete(`${url()}/api/v3/backoffice/registration-tokens/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        apply: function (clientId, successCallback, errorCallback) {
          return axios.patch(`${url()}/api/v3/backoffice/registration-tokens/${id}/apply_token`, {client_id: clientId})
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },

      }
    },
  },
  vats: {
    list: function (page_number, per_page) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/vat`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/vat/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove: function (successCallback, errorCallback) {
          return axios.delete(`${url()}/api/v3/backoffice/vat/${id}`)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make: function (body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/vat`
      return axios.post(`${baseUrl}`, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  splash: {
    make(body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/configs/wizard/splash`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  },
  pages: {
    list: function (page_number, per_page) {
      return {
        all: function (successCallback, errorCallback) {
          return axios.get(`${url()}/api/v3/backoffice/pages`, {
            params: {
              page_number,
              per_page
            }
          }).then(function (response) {
            successCallback(response.data)
          }).catch(function (error) {
            extractError(error, errorCallback)
          })
        },

      }
    },
    select: function (id) {
      var baseUrl = `${url()}/api/v3/backoffice/pages/${id}`
      return {
        edit(body, successCallback, errorCallback) {
          return axios.patch(`${baseUrl}`, body)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
        remove: function (successCallback, errorCallback) {
          var baseUrl = `${url()}/api/v3/backoffice/pages/${id}`
          return axios.delete(baseUrl)
            .then(function (response) {
              successCallback(response.data)
            }).catch(function (error) {
              extractError(error, errorCallback)
            })
        },
      }
    },
    make(body, successCallback, errorCallback) {
      var baseUrl = `${url()}/api/v3/backoffice/pages`
      return axios.post(baseUrl, body)
        .then(function (response) {
          successCallback(response.data)
        }).catch(function (error) {
          extractError(error, errorCallback)
        })
    }
  }
}

export default KeplerBackofficeSdk



// WEBPACK FOOTER //
// ./src/lib/kepler/backoffice.js